module.exports = __webpack_public_path__ + "img/sneeze.ad5913ac.svg";